/**
 * Utility function to build filter object for API calls
 * Converts chartFilters to simplified filter object
 * NOTE: This excludes direction and messagetypes (only for messages trend)
 * @param {Object} chartFilters - The chart filters from useChartFilters hook
 * @returns {Object} Simplified filter object for backend
 */
export const buildFilterObject = (chartFilters) => {
  if (!chartFilters) {
    return {
      siteids: [],
      vehiclemodels: [],
      vehicletypes: []
    };
  }

  // Ensure arrays are properly handled
  // SearchableSelect returns raw values, not objects
  const vehiclemodels = Array.isArray(chartFilters.vehiclemodels) 
    ? chartFilters.vehiclemodels
    : [];
  
  const vehicletypes = Array.isArray(chartFilters.vehicletypes)
    ? chartFilters.vehicletypes
    : [];

  const filters = {
    siteids: Array.isArray(chartFilters.siteids) ? chartFilters.siteids : [],
    vehiclemodels: vehiclemodels,
    vehicletypes: vehicletypes
    // direction and messagetypes excluded - only for messages trend
  };

  return filters;
};

/**
 * Utility function to build filter object specifically for Messages Trend API
 * Includes direction for frontend filtering only
 * @param {Object} chartFilters - The chart filters from useChartFilters hook
 * @returns {Object} Simplified filter object for backend
 */
export const buildMessagesTrendFilterObject = (chartFilters) => {
  if (!chartFilters) {
    return {
      siteids: [],
      vehiclemodels: [],
      vehicletypes: []
    };
  }

  // Ensure arrays are properly handled
  const vehiclemodels = Array.isArray(chartFilters.vehiclemodels) 
    ? chartFilters.vehiclemodels
    : [];
  
  const vehicletypes = Array.isArray(chartFilters.vehicletypes)
    ? chartFilters.vehicletypes
    : [];

  const filters = {
    siteids: Array.isArray(chartFilters.siteids) ? chartFilters.siteids : [],
    vehiclemodels: vehiclemodels,
    vehicletypes: vehicletypes
    // direction excluded - filtered on frontend in data generator
    // messagetypes excluded - filtered on frontend in data generator
  };

  return filters;
};

/**
 * Check if any filters are applied
 * @param {Object} chartFilters - The chart filters from useChartFilters hook
 * @returns {boolean} True if any filters are active
 */
export const hasActiveFilters = (chartFilters) => {
  if (!chartFilters) return false;
  
  return (
    (chartFilters.siteids && chartFilters.siteids.length > 0) ||
    (chartFilters.vehiclemodels && chartFilters.vehiclemodels.length > 0) ||
    (chartFilters.vehicletypes && chartFilters.vehicletypes.length > 0) ||
    (chartFilters.messagetypes && chartFilters.messagetypes.length > 0)
  );
};
